import { Alert, AlertColor, Snackbar, SnackbarProps } from '@mui/material'
import { SetStateAction } from 'react'

const SX_RELATIVE = { position: 'relative', top: 0, left: 0, width: '100%' }

type message = string | undefined

type SnackbarAppProps = {
  message: message
  setMessage: (state: SetStateAction<message>) => void
  severity?: AlertColor | undefined
  relative?: boolean
} & SnackbarProps

export function SnackbarApp({
  message,
  setMessage,
  severity = 'error',
  relative,
  anchorOrigin = { vertical: 'bottom', horizontal: 'center' },
  sx = { textAlign: 'left' },
  ...props
}: SnackbarAppProps) {
  const relativeSx = relative ? SX_RELATIVE : {}
  return (
    <Snackbar
      open={!!message}
      autoHideDuration={6000}
      onClose={() => setMessage(undefined)}
      anchorOrigin={anchorOrigin}
      sx={{ ...sx, ...relativeSx }}
      {...props}
    >
      <Alert
        onClose={() => setMessage(undefined)}
        severity={severity}
        variant="standard"
        sx={{ width: relative ? '100%' : 'auto' }}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}
